import { Box, Chip, Stack, useTheme } from "@mui/material";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import SkeletonIncomeCard from "../../../../../utils/ui-components/cards/skeleton/income-card";

UserStatus.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  title: PropTypes.number.isRequired,
};

function UserStatus({ isLoading, title }: any) {
  const theme: any = useTheme();
  const [statusColor, setStatusColor] = useState();
  const [statusTitle, setStatusTitle] = useState("");

  useEffect(() => {
    color(title);
  }, [title]);

  const color = (title: number) => {
    switch (title) {
      case 0:
        setStatusColor(theme.palette["info"].main);
        setStatusTitle("Inactive");
        break;
      case 1:
        setStatusColor(theme.palette["primary"].main);
        setStatusTitle("Active");
        break;
      default:
        setStatusColor(theme.palette["info"]);
        setStatusTitle("");
        break;
    }
  };

  return (
    <>
      {isLoading ? (
        <SkeletonIncomeCard />
      ) : (
        statusTitle !== "" && (
          <Box sx={{ p: 0 }}>
            <Stack alignItems="flex-end" sx={{ py: 0 }}>
              <Chip label={statusTitle} sx={{ background: statusColor, color: "#ffff", fontWeight: "bold" }} />
            </Stack>
          </Box>
        )
      )}
    </>
  );
}

export default UserStatus;
